import React from 'react'
import { X, Mail, Copy } from 'lucide-react'

interface ContactSupportModalProps {
  isOpen: boolean
  onClose: () => void
}

const ContactSupportModal = ({ isOpen, onClose }: ContactSupportModalProps) => {
  const email = 'conor@conormartin.com'

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email)
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-slate-800 rounded-xl border border-slate-700 p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-white">Contact Support</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg mb-4">
            <Mail className="h-6 w-6 text-white" />
          </div>
          
          <p className="text-slate-300 mb-4">
            Get in touch with our support team for help with your English learning journey.
          </p>
          
          <div className="bg-slate-900/50 rounded-lg p-4 mb-4">
            <p className="text-sm text-slate-400 mb-2">Email Address:</p>
            <div className="flex items-center justify-between bg-slate-700/50 rounded-lg p-3">
              <span className="text-white font-mono">{email}</span>
              <button
                onClick={copyToClipboard}
                className="text-blue-400 hover:text-blue-300 transition-colors"
                title="Copy to clipboard"
              >
                <Copy className="h-4 w-4" />
              </button>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={`mailto:${email}`}
              className="flex-1 inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200"
            >
              <Mail className="h-4 w-4 mr-2" />
              Send Email
            </a>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-slate-600 text-white font-semibold rounded-lg hover:bg-slate-700 transition-all duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactSupportModal